export default from './MainSummaryBar';



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/MainSummaryBar/index.js